import { call, put } from 'redux-saga/effects'
import { get, URL_VARIABLES } from 'services/api'
import { OCR_TYPES } from '../reducers/ocr'

export function* handleOcrTypes(action) {
  const { token } = action.payload

  const res = yield call(get, {
    url: `/onboarding/ocr/types`,
    token,
    source: URL_VARIABLES.ANTIFRAUDE,
  })

  if (res.status === 200 && res.data.types) {
      const { types } = res.data

      yield put({
        type: OCR_TYPES,
        payload: types,
      })
  }
}
